import { GoDefElementOrgLevel1 } from '../types';
import { EntityService } from './EntityService';

export class GoDefElementOrgLevel1Service extends EntityService<GoDefElementOrgLevel1> {
    //protected childrenEntities = ['App03PortfolioUsers($expand=User)'];

    constructor() {
        super(`/GoDefElementOrgLevel1s`);
    }

}